module.exports = __webpack_public_path__ + "img/tanker_grey.54e788ed.svg";